import { motion } from "framer-motion";
import ChapterHeading from "@/components/landing/ChapterHeading";

const IMG = "/photos/esterno_pro.webp";

const STATS = [
  { value: "30 m²", label: "Tutta la casa per voi" },
  { value: "1500", label: "Anno di costruzione" },
  { value: "2", label: "Ospiti · letto matrimoniale" },
  { value: "6 km", label: "Da Spoleto centro" },
];

export default function Dimora() {
  return (
    <section id="dimora" data-testid="dimora-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-36">
      <ChapterHeading
        eyebrow="Capitolo 01"
        title="La Casa"
        subtitle="Tranquilla, accogliente e decisamente riservata: una tiny house ricavata dentro un antico edificio centenario."
      />

      <div className="grid items-start gap-12 lg:grid-cols-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative lg:col-span-7"
        >
          <div className="overflow-hidden rounded-sm shadow-2xl shadow-stone-900/20">
            <motion.img
              src={IMG}
              alt="Il giardino privato con amaca, sedie e tavolo tra le mura in pietra"
              className="aspect-[4/3] w-full object-cover"
              whileHover={{ scale: 1.04 }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            />
          </div>
          <div className="absolute -bottom-6 -right-3 rounded-sm bg-olive px-6 py-4 text-linen shadow-xl sm:-right-6">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-linen/70">Punteggio ospiti</p>
            <p className="font-serif text-3xl">8,2<span className="text-lg text-linen/60"> / 10</span></p>
          </div>
          <motion.img
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, delay: 0.25 }}
            src="/photos/cancello_pro.webp"
            alt="Il cancello d'ingresso della casa, al civico 26 del borgo"
            loading="lazy"
            className="absolute -bottom-10 -left-4 hidden w-2/5 rounded-sm border-4 border-linen object-cover shadow-2xl shadow-stone-900/30 sm:block"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5"
        >
          <p className="text-base font-light leading-relaxed text-stone-600 sm:text-lg">
            Ristrutturata con cura per tramandare e ricordare le origini di questo posto:
            proverai la tranquillità e la riservatezza di una casa tutta per voi, stando
            comunque al centro di un bellissimo borgo.
          </p>
          <p className="mt-5 text-base font-light leading-relaxed text-stone-600">
            Il giardino, circondato da mura secolari, rende lo spazio esterno sereno e riservato —
            per stare in pace con voi stessi, senza andare troppo lontano. Travi antiche in legno,
            pavimenti in cotto, ingresso indipendente a piano terra, WiFi gratuito, riscaldamento
            e una cucina attrezzata di tutto punto.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-sm border border-stone-300/50 bg-stone-300/50">
            {STATS.map((s) => (
              <div key={s.label} className="bg-linen p-5">
                <p className="font-serif text-2xl text-terracotta sm:text-3xl">{s.value}</p>
                <p className="mt-1 text-xs uppercase tracking-[0.12em] text-stone-500">{s.label}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
